export default __webpack_public_path__ + "static/media/c3-logo.1ec6de07.png";